export const OUTBOUND_CALLING_OPS = {
  // Config Operations
  GETTING_OUTBOUND_CONFIG: 'GETTING_OUTBOUND_CONFIG',
  GET_OUTBOUND_CONFIG_SUCCESS: 'GET_OUTBOUND_CONFIG_SUCCESS',
  GET_OUTBOUND_CONFIG_FAILURE: 'GET_OUTBOUND_CONFIG_FAILURE',

  // Agent Status Operations
  GETTING_AGENT_STATUS: 'GETTING_AGENT_STATUS',
  GET_AGENT_STATUS_SUCCESS: 'GET_AGENT_STATUS_SUCCESS',
  GET_AGENT_STATUS_FAILURE: 'GET_AGENT_STATUS_FAILURE',

  SETTING_AGENT_STATUS: 'SETTING_AGENT_STATUS',
  SET_AGENT_STATUS_SUCCESS: 'SET_AGENT_STATUS_SUCCESS',
  SET_AGENT_STATUS_FAILURE: 'SET_AGENT_STATUS_FAILURE',

  // Ticket Operations
  GETTING_TICKETS: 'GETTING_TICKETS',
  GET_TICKETS_SUCCESS: 'GET_TICKETS_SUCCESS',
  GET_TICKETS_FAILURE: 'GET_TICKETS_FAILURE',

  // Update Tickets
  UPDATING_TICKET: 'UPDATING_TICKET',
  UPDATE_TICKET_SUCCESS: 'UPDATE_TICKET_SUCCESS',
  UPDATE_TICKET_FAILURE: 'UPDATE_TICKET_FAILURE',

  // UI State
  SET_CURRENT_TICKET: 'SET_CURRENT_TICKET',
  CLEAR_CURRENT_TICKET: 'CLEAR_CURRENT_TICKET',

  // Admin Dashboard Operations
  GETTING_ADMIN_DASHBOARD_STATS: 'GETTING_ADMIN_DASHBOARD_STATS',
  GET_ADMIN_DASHBOARD_STATS_SUCCESS: 'GET_ADMIN_DASHBOARD_STATS_SUCCESS',
  GET_ADMIN_DASHBOARD_STATS_FAILURE: 'GET_ADMIN_DASHBOARD_STATS_FAILURE',

  // Admin Dashboard - Available Agents Operations
  GETTING_AVAILABLE_AGENTS: 'GETTING_ADMIN_DASHBOARD_AVAILABLE_AGENTS',
  GET_AVAILABLE_AGENTS_SUCCESS: 'GET_ADMIN_DASHBOARD_AVAILABLE_AGENTS_SUCCESS',
  GET_AVAILABLE_AGENTS_FAILURE: 'GET_ADMIN_DASHBOARD_AVAILABLE_AGENTS_FAILURE',

  // Admin Dashboard - Tickets Queue Operations (Open Tickets)
  GETTING_TICKETS_QUEUE: 'GETTING_ADMIN_DASHBOARD_TICKETS_QUEUE',
  GET_TICKETS_QUEUE_SUCCESS: 'GET_ADMIN_DASHBOARD_TICKETS_QUEUE_SUCCESS',
  GET_TICKETS_QUEUE_FAILURE: 'GET_ADMIN_DASHBOARD_TICKETS_QUEUE_FAILURE',

  // Admin Dashboard - Closed Tickets Operations
  GETTING_CLOSED_TICKETS: 'GETTING_ADMIN_DASHBOARD_CLOSED_TICKETS',
  GET_CLOSED_TICKETS_SUCCESS: 'GET_ADMIN_DASHBOARD_CLOSED_TICKETS_SUCCESS',
  GET_CLOSED_TICKETS_FAILURE: 'GET_ADMIN_DASHBOARD_CLOSED_TICKETS_FAILURE'
};

